// src/components/VideoRoom.js
import React from 'react';
import { useOpenVidu } from '../contexts/OpenViduContext';
import { VideoComponent } from './VideoComponent';

export const VideoRoom = () => {
  const { publisher, subscribers, isMobile } = useOpenVidu();

  const styles = {
    container: {
      padding: isMobile ? '80px 10px 100px 10px' : '20px',
      background: '#f8f9fa',
      minHeight: '100vh',
      boxSizing: 'border-box',
    },
    title: {
      textAlign: 'center',
      color: '#333',
      marginBottom: '20px',
      fontSize: isMobile ? '20px' : '24px',
      fontWeight: '600',
    },
    videoGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: isMobile ? '8px' : '10px',
      maxWidth: '1400px',
      margin: '0 auto',
    },
    emptyState: {
      textAlign: 'center',
      color: '#666',
      fontSize: isMobile ? '16px' : '18px',
      marginTop: '50px',
    }
  };

  const allParticipants = [
    ...(publisher ? [{ streamManager: publisher, isPublisher: true }] : []),
    ...subscribers.map(subscriber => ({ streamManager: subscriber, isPublisher: false }))
  ];

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>
        Video Call {isMobile && '📱'}
        {!isMobile && '💻'}
      </h2>
      
      <div style={styles.videoGrid}>
        {allParticipants.map((participant, index) => (
          <VideoComponent 
            key={participant.streamManager.id || index}
            streamManager={participant.streamManager}
            isPublisher={participant.isPublisher}
            isMobile={isMobile}
          />
        ))}
        
        {allParticipants.length === 0 && (
          <div style={styles.emptyState}>
            Waiting for participants to join...
          </div>
        )}
      </div>
    </div>
  );
};
